import script from "./files-section.vue?vue&type=script&setup=true&lang=js"
export * from "./files-section.vue?vue&type=script&setup=true&lang=js"

import "./files-section.vue?vue&type=style&index=0&id=0a8420ee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8420ee"]])

export default __exports__